import DoktrinalneDefinicieUpdate from './DoktrinalneDefinicieUpdate';

export default DoktrinalneDefinicieUpdate;
